// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventContextAction, LocationList } from '@/audit/api/types';
import { Stack, Typography } from '@mui/material';

interface LocationDifference {
  id: string;
  name: string;
  isOld: boolean;
  isNew: boolean;
}

interface Props {
  property: LocationList;
  action: AuditEventContextAction;
}

export function AuditProjectLocationListLabel(props: Props) {
  const locations: LocationDifference[] = [];

  props.property.oldValue?.forEach(({ id, name }) => {
    locations.push({ id, name, isOld: true, isNew: false });
  });

  props.property.newValue?.forEach(({ id, name }) => {
    const location = locations.find((location) => location.id === id);

    if (location === undefined) {
      return locations.push({ id, name, isOld: false, isNew: true });
    }

    location.isNew = true;
  });

  return (
    <Stack>
      <Typography component="span" variant="caption" fontWeight="bold">
        {props.property.name}:
      </Typography>
      {locations.map(({ id, name, isNew, isOld }) => {
        if (isNew === isOld) {
          return null;
        }

        return (
          <Typography key={id} variant="caption" marginLeft={2}>
            <Typography component="span" variant="inherit">
              {name}
            </Typography>
            {props.action !== 'DELETE' && (
              <>
                {' '}
                <Typography
                  component="span"
                  variant="inherit"
                  sx={{ textDecoration: 'underline' }}
                >
                  {isNew ? 'added' : 'removed'}
                </Typography>
              </>
            )}
          </Typography>
        );
      })}
    </Stack>
  );
}
